export default __webpack_public_path__ + "static/media/TeamsAssets-Regular.ace6ce92.ttf";